import { render, staticRenderFns } from "./alarm-column-value-status.vue?vue&type=template&id=97c87b82&"
import script from "./alarm-column-value-status.vue?vue&type=script&lang=js&"
export * from "./alarm-column-value-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports